import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ApplicationFeesService {
  getAll(
    organizationId: string,
    propertyId: string,
    numAdults: number,
    floorPlanId: ?string,
  ) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    // Without a floor plan the API quotes the cheapest plan's deposit.
    const params = floorPlanId
      ? `numAdults=${numAdults}&floorPlanId=${floorPlanId}`
      : `numAdults=${numAdults}`;
    return request(
      `${apiURL}/${organizationId}/${propertyId}/application-fees?${params}`,
      options,
    );
  }
}

export default ApplicationFeesService;
